/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Start_Daily_ChallengeInputs */

const bn_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিদিনের চ্যালেঞ্জ শুরু করুন`)
};

const de_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starten Sie die tägliche Herausforderung`)
};

const el_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ξεκινήστε την καθημερινή πρόκληση`)
};

const en_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start daily challenge`)
};

const es_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar desafío diario`)
};

const fr_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer le défi quotidien`)
};

const hi_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`दैनिक चुनौती शुरू करें`)
};

const hu_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kezdje el a napi kihívást`)
};

const id_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai tantangan harian`)
};

const it_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia la sfida quotidiana`)
};

const ja_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`毎日のチャレンジを開始する`)
};

const ko_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일일 챌린지 시작`)
};

const nl_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met de dagelijkse uitdaging`)
};

const pl_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij codzienne wyzwanie`)
};

const pt_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece o desafio diário`)
};

const ru_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать ежедневное испытание`)
};

const sv_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Börja daglig utmaning`)
};

const tr_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Günlük mücadeleyi başlat`)
};

const uk_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почніть щоденне завдання`)
};

const vi_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu thử thách hàng ngày`)
};

const zh_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始每日挑战`)
};

const zh_hant_action_start_daily_challenge = /** @type {(inputs: Action_Start_Daily_ChallengeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始每日挑戰`)
};

/**
* | output |
* | --- |
* | "Start daily challenge" |
*
* @param {Action_Start_Daily_ChallengeInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const action_start_daily_challenge = /** @type {((inputs?: Action_Start_Daily_ChallengeInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Start_Daily_ChallengeInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_action_start_daily_challenge(inputs)
	if (locale === "de") return de_action_start_daily_challenge(inputs)
	if (locale === "el") return el_action_start_daily_challenge(inputs)
	if (locale === "en") return en_action_start_daily_challenge(inputs)
	if (locale === "es") return es_action_start_daily_challenge(inputs)
	if (locale === "fr") return fr_action_start_daily_challenge(inputs)
	if (locale === "hi") return hi_action_start_daily_challenge(inputs)
	if (locale === "hu") return hu_action_start_daily_challenge(inputs)
	if (locale === "id") return id_action_start_daily_challenge(inputs)
	if (locale === "it") return it_action_start_daily_challenge(inputs)
	if (locale === "ja") return ja_action_start_daily_challenge(inputs)
	if (locale === "ko") return ko_action_start_daily_challenge(inputs)
	if (locale === "nl") return nl_action_start_daily_challenge(inputs)
	if (locale === "pl") return pl_action_start_daily_challenge(inputs)
	if (locale === "pt") return pt_action_start_daily_challenge(inputs)
	if (locale === "ru") return ru_action_start_daily_challenge(inputs)
	if (locale === "sv") return sv_action_start_daily_challenge(inputs)
	if (locale === "tr") return tr_action_start_daily_challenge(inputs)
	if (locale === "uk") return uk_action_start_daily_challenge(inputs)
	if (locale === "vi") return vi_action_start_daily_challenge(inputs)
	if (locale === "zh") return zh_action_start_daily_challenge(inputs)
	return zh_hant_action_start_daily_challenge(inputs)
});